require "../polyfills/xhr-xdr" #TODO : Test if we can remove this now it's in Polyfill service
require "../utils/console-shim"



// WEBPACK FOOTER //
// ./src/utils/load-polyfills.coffee